module.exports = __webpack_public_path__ + "static/media/zone_report_cover.4d8fc8d5.png";